// Unpublished Work © 2024 Deere & Company.

import { axios } from "../index";
import { RBACRolesResponse } from "./types";

const RbacApi = {
  getUserRoles: (
    url: string,
    token: string,
    userId: string
  ): Promise<RBACRolesResponse> =>
    axios
      .getWithRetries(`${url}/rbac/v1/user/auth-info?userId=${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { roles, businessActivities } = response.data;
        return {
          userId: response.data.userId,
          roles,
          businessActivities,
        };
      }),
};

export default RbacApi;
